import * as actions from '../actions/Stuff'

const initialState = {
  error: '',
  loading: false,
  packageDetails: null,
  scanSuccess: false
}

const StuffReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_SCAN_PACKAGE_DETAILS:
      return {
        ...state,
        packageDetails: action.packageDetails
      }
    case actions.SET_SCAN_PACKAGE_LOADER:
      return {
        ...state,
        loading: action.loading
      }
    case actions.GET_SCAN_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.POST_SCAN_PACKAGE_SUCCESS:
      return {
        ...state,
        scanSuccess: action.packageSuccess
      }
    case actions.POST_SCAN_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default StuffReducer
